module.exports = __webpack_public_path__ + "a3a6d56a1d38ace29dc8c3168b96acbb.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/games/sm_image_3.png
// module id = 299
// module chunks = 0